/*
These functions make sure WordPress
and Foundation play nice together.
*/

(function($) {
	$(document).ready(function() {
		WebFont.load({
		  google: {
		    families: ['Hind:400,500,700']
		  },
		  active: function() {
		  	$(document).foundation();
		  	TWD.init.HeroVideo();
		  	TWD.init.imgToSVG();
		  	TWD.init.lineAnimation();
		  	TWD.init.ContentSlider();
		  	TWD.init.Animations();
		  	TWD.animations.Diploma();
		  	TWD.init.CertificationsAjax();
		  	TWD.init.GallerySlider();
		  	TWD.init.AlertBar();
		  },
		});

		$('#hero .scroll-down').on('click', function(e) {
  		e.preventDefault();

			 $('html,body').animate({
    		scrollTop: $('#hero').next().offset().top
				}, 1000);
		});

		$('.accordion p:empty, .orbit p:empty').remove();

		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
			if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			  $(this).wrap("<div class='widescreen responsive-embed'/>");
			} else {
			  $(this).wrap("<div class='responsive-embed'/>");
			}
		});


		$('[data-fancybox]').fancybox({
			thumbs : {
				autoStart : true
			}
		});
	});

	window.TWD = {};

	TWD.init = $.extend({
		HeroVideo: function() {
			if($('#hero video').length > 0) {
				$('#hero').vidbacking();
			}
		},
		imgToSVG: function() {
			jQuery('img').filter(function() {
        return this.src.match(/.*\.svg$/);
    	}).each(function(){
		    var $img = jQuery(this);
		    console.log($img)
		    var imgID = $img.attr('id');
		    var imgClass = $img.attr('class');
		    var imgURL = $img.attr('src');

		    jQuery.get(imgURL, function(data) {
	        // Get the SVG tag, ignore the rest
	        var $svg = jQuery(data).find('svg');

	        // Add replaced image's ID to the new SVG
	        if(typeof imgID !== 'undefined') {
	            $svg = $svg.attr('id', imgID);
	        }
	        // Add replaced image's classes to the new SVG
	        if(typeof imgClass !== 'undefined') {
	            $svg = $svg.attr('class', imgClass+' replaced-svg');
	        }

	        // Remove any invalid XML tags as per http://validator.w3.org
	        $svg = $svg.removeAttr('xmlns:a');

	        // remove duplicates id's
	        $svg.find('[id]').each(function(index, el) {

                let current_id = jQuery(this).attr('id'),
                    random_id = '_' + (
                    Number(String(Math.random()).slice(2)) +
                    Date.now() +
                    Math.round(performance.now())
                  ).toString(36);

                $svg.find('#'+current_id).prop('id',random_id);
                let svg_html = $svg.html() ; // must be after replaceding ID
                svg_html = svg_html.replace('url(#'+current_id+')','url(#'+random_id+')');
                svg_html = svg_html.replace('xlink:href="#'+current_id+'"','xlink:href="#'+random_id+'"');

                $svg.html(svg_html);
            });
	        // Replace image with new SVG
	        $img.replaceWith($svg);

		    }, 'xml');

			});
		},
		lineAnimation: function() {
			var element = $('.title svg');
			if(element.length> 0) {
				$(element).each(function(){
					new Vivus(this, {duration: 1000, type: 'sync'});
				});
			}
		},
		ContentSlider: function() {
			if($('.content-slider .slides').length > 0) {
				$('.content-slider .slides').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			    var i = (currentSlide ? currentSlide : 0) + 1;
			    $('.content-slider .meta .info').html('<span>'+i+'</span>' + '/' + slick.slideCount);
			  });
				$('.content-slider .slides').slick({
					infinite: false,
					arrows: true,
					dots: false,
					autoplay: true,
  				autoplaySpeed: 10000,
					appendArrows: $('.content-slider .meta .nav'),
					prevArrow: '<button type="button" class="slick-prev icon"><i class="fal fa-long-arrow-left"></i></button>',
					nextArrow: '<button type="button" class="slick-next icon"><i class="fal fa-long-arrow-right"></i></button>'
				});
			}
		},
		Animations: function() {
			ScrollReveal().watch('h2 div, .cta',
		    function onEnter (el) {
		      el.classList.add('active');

		      TWD.animations.animation1();
		    },
		    function onExit (el) {
		      // el.classList.remove('active')
		    }
			);

			var delay = 100;

			// Hero
			ScrollReveal().reveal('#hero .caption h1', {delay:500,  origin: 'bottom',distance: '100px', duration: 1500});
			ScrollReveal().reveal('#hero .caption p', {delay:700,  origin: 'bottom',distance: '100px', duration: 1500});
			ScrollReveal().reveal('#hero .caption .button', {delay:900,  origin: 'bottom',distance: '100px', duration: 1500});


			jQuery('.list').each(function(){
				delay = 100;
				var ulli = $(this).find('ul li');
				ulli.each(function(){
					delay += 200;
					ScrollReveal().reveal(this, {delay:delay,  origin: 'bottom',distance: '50px', duration: 1000});
				});
			});

			jQuery('.list ul li')

			delay = 100;
			jQuery('.stats ul li').each(function(){
				delay += 200;
				ScrollReveal().reveal(this, {delay:delay,  origin: 'bottom',distance: '50px', duration: 1000});
			});

			delay = 100;
			jQuery('.teams ul li *').each(function(){
				delay += 40;
				ScrollReveal().reveal(this, {delay:delay,  origin: 'bottom',distance: '50px', duration: 1000});
			});

			// ScrollReveal().reveal('.simple-content .content *:not(.ajax-loader,.gallery-slider)', {delay:300,  origin: 'bottom',distance: '50px', duration: 1000,  afterReveal: maybeAnimateIcons});
			// ScrollReveal().reveal('.simple-content .content p, .simple-content .content span:not(.ajax-loader), .simple-content .content form', {delay:500,  origin: 'bottom',distance: '50px', duration: 1000});

			ScrollReveal().reveal('.text-image .inner-content *', {delay:300,  origin: 'bottom',distance: '50px', duration: 1000});

			ScrollReveal().reveal('.cta h2', {delay:1000,  origin: 'bottom',distance: '50px', duration: 1000});
			ScrollReveal().reveal('.cta .button', {delay:1200,  origin: 'bottom',distance: '50px', duration: 1000});

			ScrollReveal().reveal('.content-slider .slick-active *', {delay:300,  origin: 'bottom',distance: '50px', duration: 1000});

			function maybeAnimateIcons(el){
				// this doesn't animate
				var svg = $(el).find('svg');
				if(svg.length > 0) {
					const svg_anim = new Vivus(svg[0], {duration: 500, type: 'delayed'});
					svg_anim.stop().reset().play(1);
				}

			}
		},
		CertificationsAjax: function() {
			if($('.certifications').length > 0) {
				$('.certifications ul li .button').on('click', function(e) {
					e.preventDefault();
					var pageid = $(this).data('pageid');
					var contentid = $(this).data('contentid');
					console.log($(this));

					var str = '&pageid=' + pageid + '&contentid=' + contentid + '&action=get_certification_ajax';

					jQuery.ajax({
					  type: "POST",
					  dataType: "html",
					  url: AJAX.ajaxurl,
					  data: str,
					  success: function (data) {
					  	$('#certificationModal .content').html(data);
					  	$('#certificationModal').foundation('open');
					  },
					  error: function (jqXHR, textStatus, errorThrown) {
					      // $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
					  }
					});
				});
			}
		},
		GallerySlider:function() {
			if($('.gallery-slider').length >0) {
				$('.gallery-slider').slick({
					arrows: true,
					dots: false,
					autoplay: true,
					autoplaySpeed: 5000,
					slidesToShow: 3,
		  		slidesToScroll: 3,
					appendArrows: $('.gallery-slider').prev(),
					prevArrow: '<button type="button" class="slick-prev icon"><i class="fal fa-long-arrow-left"></i></button>',
					nextArrow: '<button type="button" class="slick-next icon"><i class="fal fa-long-arrow-right"></i></button>',
					responsive: [
				    {
				      breakpoint: 1024,
				      settings: {
				        slidesToShow: 2,
				        slidesToScroll: 2,
				      }
				    },
				    {
				      breakpoint: 500,
				      settings: {
				        slidesToShow: 1,
				        slidesToScroll: 1,
				      }
				    },
	  			]
				});
			}
		},
		AlertBar: function() {
			let alertbar = $('#alert-bar');
			if(alertbar.length > 0) {
				if(Cookies.get('alert-bar') != 1) {
					alertbar.addClass('active').slideDown(500);
				}

				alertbar.find('.close-button').on('click', function() {
					alertbar.slideUp(500,function(){
						alertbar.removeClass('active').remove();
					});
					Cookies.set('alert-bar', 1, { expires: 7 });
				});
			}
		}
	});

	TWD.animations = $.extend({
		animation1: function() {
			var can = document.getElementById('animation1');
			if($(can).length > 0) {
				var ctx = can.getContext('2d');
				var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
				var offset = { value: 0 };

				path.setAttribute(
				  "d",
				  "M183.223 840.193L90.971 508.127M179.108 805.786L94.6007 506.755M92.5086 503.123L91.028 508.249M49.8663 351.301L92.4618 503.151M46.4587 347.638L49.8754 351.284M48.224 344.239L46.5156 347.657M19.9026 244.505L48.1477 344.182M10.0509 233.171L19.9595 244.562M254.463 62.2961L9.93709 233.171M16.2683 228.822L7.38475 196.47M2.66169 191.297L7.33122 196.423M27.0641 172.942L2.69123 191.282M39.8337 191.396L26.9638 173.056M32.9739 196.441L49.8299 184.024M51.9198 188.763L49.7559 183.864M64.2349 179.863L51.9346 188.863M62.555 175.079L64.2634 179.75M79.1399 163.103L62.5117 175.064M80.9918 168.229L79.1695 163.103M93.5335 158.917L81.0055 168.372M91.8821 153.705L93.5905 158.831M108.909 141.929L91.8252 153.777M36.0752 206.889L28.6722 181.372M5.03288 189.635L3.43837 182.231M0 179.486L3.41675 182.106M2.27783 177.478L0 179.529M2.46351 167.624L2.34958 177.535M9.06921 176.687L2.34958 167.574M7.97241 144.164L9.11133 176.631M35.4921 178.45L8.04416 144.161M33.4272 182.159L35.4773 178.514M113.256 152.909L108.017 139.694M123.743 128.088L108.026 139.594M128.915 142.012L123.79 128.115M142.282 118.299L124.856 131.057M144.942 123.118L142.209 118.22M158.594 112.894L144.927 123.147M156.757 108.081L158.579 112.98M175.592 94.6392L156.8 108.081M177.998 99.4089L175.606 94.7383M192.762 88.6734L177.956 99.3816M190.298 83.9459L192.69 88.6165M209.006 70.5038L190.328 84.0598M198.741 48.3744L208.991 70.4742M200.578 45.228L198.756 48.4177M198.129 40.8855L200.521 45.3283M193.289 33.7361L196.82 42.3938M198.214 40.8286L196.961 42.4234M195.132 32.3988L193.31 33.6518M192.797 21.0493L195.189 32.4409M199.374 26.7451L192.769 21.0493M201.253 25.1651L199.317 26.7599M194.232 1L201.293 25.2642M200.354 1.19936L213.11 17.7172M216.537 14.7987L213.12 17.7605M213.817 6.80974L216.55 14.7839M223.641 13.0182L213.846 6.75277M249.852 65.5108L223.657 12.9954M218.06 79.731L35.9476 206.862M203.923 49.8416L218.16 79.8016M111.336 137.214L107.919 111.127M121.325 129.903L108 111.221M285.454 913.432L63.8204 215.581M472.285 944.211L202.02 255.245M197.232 124.681L243.358 229.94M202.02 255.217L316.253 186.297M355.59 264.083L316.184 186.392M254.495 62.2448L312.808 188.35M63.8774 215.577L197.245 124.672M118.861 592.833L165.329 572.784M165.947 759.175L216.515 745.277M94.6656 506.864L142.158 484.422M287.728 420.663L322.579 404.259M161.925 481.209L253.608 439.629M123.202 371.2L216.024 321.076M232.512 305.128L337.179 251.587M98.062 323.379L204.209 260.953M76.6515 255.912L215.144 165.804M280.24 118.048L213.271 161.336M37.2562 276.589L67.3237 257.223M55.5427 344.123L88.5713 323.618M67.9648 395.197L104.98 375.148M284.302 446.897L454.001 871.235M359.084 278.168L323.095 206.172M109.294 313.102L192.549 262.979M295.114 412.375L339.304 392.325M158.315 356.102L183.827 341.065M309.372 194.653L214.842 251.953M273.725 125.359L220.31 161.357M21.6816 234.272L250.262 73.9919"
				);

				var totalLength = path.getTotalLength();
				var t = TweenMax.from(offset, 100, { value: totalLength });
				var path = new Path2D(path.getAttribute("d"));

				if(!$(can).hasClass('active')) {
					render();
				};
				can.classList.add('active');

				function render(elapsedTime) {
					if (elapsedTime >= 6500) return;
				  ctx.clearRect(0, 0, 474, 946);
				  ctx.setLineDash([totalLength, totalLength]);
				  ctx.lineDashOffset = offset.value;

				  ctx.stroke(path);
				  requestAnimationFrame(render);
				}
			}
		},
		Diploma: function() {
			if($('#diploma-animation').length > 0) {
				var addvalue = document.getElementById('diploma-animation');
				var diploma_anim;
				var delay = 100;

				function createAnimation(theContainer, theData, renderer) {
			    var anim = bodymovin.loadAnimation({
			        container: theContainer, // the dom element
			        animType: renderer,
			        loop: false,
			        autoplay: false,
			        animationData: animations[theData] // the animation data
			    });

			    return anim;
				}

				var svgElement = document.getElementById('hiddenlayer');
				var maskedElement = document.querySelector('#mask-circle');
				var circleFeedback = document.querySelector('#circle-shadow');
				var svgPoint = svgElement.createSVGPoint();

				function cursorPoint(e, svg) {
			    svgPoint.x = e.clientX;
			    svgPoint.y = e.clientY;
			    return svgPoint.matrixTransform(svg.getScreenCTM().inverse());
				}

				function update(svgCoords) {
			    maskedElement.setAttribute('cx', svgCoords.x);
			    maskedElement.setAttribute('cy', svgCoords.y);
			    circleFeedback.setAttribute('cx', svgCoords.x);
			    circleFeedback.setAttribute('cy', svgCoords.y);
				}

				$('.text-image figure').on('mousemove', function(e){
			    window.addEventListener('mousemove', function (e) {
			        update(cursorPoint(e, svgElement));
			    }, false);

			    document.addEventListener('touchmove', function (e) {
			        var touch = e.targetTouches[0];
			        if (touch) {
			            update(cursorPoint(touch, svgElement));
			        }
			    }, false);
				});

				$(document).on('mousemove', function(event){
			    var x = event.clientX;     // Get the horizontal coordinate
			    var y = event.clientY;     // Get the vertical coordinate
			    var coor = "X coords: " + x + ", Y coords: " + y;

			    $(maskedElement).removeClass('twiz');
			    $(circleFeedback).removeClass('twiz');
				});

				function getRandomInt(min, max) {
				  min = Math.ceil(min);
				  max = Math.floor(max);
				  return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
				}

				var randPosx;
				var randPosy;

				function moveCircleRandomly() {
			    randPosx = getRandomInt(0, 90);
			    randPosy = getRandomInt(0, 90);

			    $(maskedElement).addClass('twiz');
			    $(circleFeedback).addClass('twiz');

			    $(maskedElement).attr('cx', randPosx+'%');
			    $(circleFeedback).attr('cx', randPosx+'%');

			    $(maskedElement).attr('cy', randPosy+'%');
			    $(circleFeedback).attr('cy', randPosy+'%');

			    setTimeout(function () {
			        moveCircleRandomly();
			    }, 1000);
				}

				moveCircleRandomly();

				ScrollReveal().reveal('#diploma-animation', {delay:0, useDelay: 'once',  origin: 'bottom',distance: '300px', scale: 0.1, duration: 500, viewFactor: 0.5,afterReveal: function (domEl) {

				  diploma_anim = createAnimation(addvalue, 'addvalue', 'svg');

				  $('#addvalue').addClass('anim_active').siblings().removeClass('anim_active');
				  diploma_anim.playSegments([470, 620], true);
				  adjustsize = setTimeout(function () {
				      $('#diploma-animation').addClass('adjustsizeandpos');
				  }, 5000);
				  wizardon = setTimeout(function () {
				      $('#mask-circle, #circle-shadow').addClass('wizard-on');
				      $('#diploma-animation').removeClass('anim_active');

				      $('.diploma').addClass('active');
				      $('#diploma-animation').hide()
				  }, 5100);
				}});
			}
		}
	});

	$('.list ul li').on('mouseenter', function() {
		var svg = $(this).find('svg');
		if(svg.length > 0) {
			const svg_anim = new Vivus(svg[0], {duration: 500, type: 'delayed'});
			svg_anim.stop().reset().play(1);
		}
	});

	// SIMPLE GOOGLE MAP
	var map;
	$.googleMap = $.extend({
	  gmap_new_map: function( $el ) {
	    var $markers = $el.find('.marker');
	    var $mapType = $el.data('map_type_id') != undefined ? $el.data('map_type_id') : google.maps.MapTypeId.ROAAOBVAP;
	    var args = {
	      zoom: 16,
	      center: new google.maps.LatLng(0, 0),
	      scrollwheel: false,
	      navigationControl: false,
	      mapTypeControl: false,
	      scaleControl: false,
	      draggable: false,
	      zoomControl: false,
	      streetViewControl: false,
	      styles: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}],
	      mapTypeId : $mapType
	    };

	    map = new google.maps.Map( $el[0], args);

	    // add a markers reference
	    map.markers = [];

	    // add markers
	    $markers.each(function(){
	      $.googleMap.gmap_add_marker( $(this), map );
	    });

	    // center map
	    $.googleMap.gmap_center_map( map );

	    return map;
	  },

	  gmap_add_marker: function( $marker, map ) {
	    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	    var marker = new google.maps.Marker({
	      position: latlng,
	      map: map,
	      icon: templateDir+'/assets/images/google-map-pin.png'
	    });

	    // add to array
	    map.markers.push( marker );

	    // console.log(latlng);


	    // var cityCircle = new google.maps.Circle({
	    //     strokeColor: '#fade62',
	    //     strokeOpacity: 0.8,
	    //     strokeWeight: 0,
	    //     fillColor: '#fade62',
	    //     fillOpacity: 0.35,
	    //     map: map,
	    //     center: latlng,
	    //     // radius: Math.sqrt(citymap[city].population) * 100
	    //     radius: Math.sqrt(150000) * 100
	    //   });



	    // if marker contains HTML, add it to an infoWindow
	    if( $marker.html() )
	    {
	      // create info window
	      var infowindow = new google.maps.InfoWindow({
	        content: $marker.html()
	      });

	      // show info window when marker is clicked
	      google.maps.event.addListener(marker, 'click', function() {
	        infowindow.open( map, marker );
	        console.log('click');
	      });
	    }
	  },

	  gmap_center_map: function( map ) {
	    var bounds = new google.maps.LatLngBounds();

	    // loop through all markers and create bounds
	    $.each( map.markers, function( i, marker ){
	      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
	      bounds.extend( latlng );
	    });

	    // only 1 marker?
	    if( map.markers.length == 1 ) {
	      // set center of map
	      map.setCenter( bounds.getCenter() );
	      // map.setZoom( 19 );
	      // map.panBy(150,0);
	    } else {
	      // fit to bounds
	      map.fitBounds( bounds );
	    }
	  }
	});

	if( $('.google-map').length ){
	  var contact_gmap = $.googleMap.gmap_new_map($('.google-map .map'));
	}
})( jQuery );